<div class="content">
  <div class="main">
    <div class="container-fluid full-width">
      <div class="top-cont">
        <div class="business-services__container_pay">
          <div class="payment-services__inner-div_bus cus-bnd">
            <nav aria-label="breadcrumb" class="bread_cus">
              <ol class="breadcrumb">
                <li class="breadcrumb-item item-with-underline"><a href="/business-services/">Business Services</a></li>
                <li class="breadcrumb-item active" aria-current="page">Continuous Bond Application
                </li>
              </ol>
            </nav>
            <span>
              <h3 class="payment-services__inner-div--heading_bus bnd-0">Continuous Bond Application
              </h3><br>
              <hr class="payment-services__hr_bus">
            </span>
            <div class="payment-services__inner-div--content bus_wor0">
              Complete the application and get access to <br>streamlined Customs clearance.

            </div>

          </div>

        </div>
        <img class="curved-image-media-value" src="../../../../assets/redesignImages/Vector.png">

      </div>

      <div class="container-new1 input-form">
        <form id="bonds-form" method="post" #userForm="ngForm" (ngSubmit)="onSubmit()" action="/bond-submit/">
          <div id="errors-bonds-form"></div>
          <div class="sr-only">
            <input type="hidden" name="posted" value="True">
            <input type="checkbox" name="BotTrap" id="BotTrap" value="1" tabindex="-1">
            <input type="hidden" name="CountryCode" id="CountryCode" value="US">
            <input type="hidden" name="LanguageCode" id="LanguageCode" value="EN">
            <input type="hidden" name="CampaignID" id="CampaignID" value="5">
            <input type="hidden" name="WebtrendsID" id="WebtrendsIDx" value="CAPITAL_US">
            <input type="hidden" name="RegionCode" id="RegionCode" value="US">
            <input type="hidden" name="SourceID" id="SourceID" value="1">
            <input type="hidden" name="posted" value="True">
            <input type="hidden" name="Referrer" id="Referrer" value="https://upscapital.com/contact-ups-capital/">
            <input type="hidden" name="ExistingCustomer" id="ExistingCustomer" value="0">
            <input type="hidden" name="CaptchaVal" id="CaptchaVal" value="">
          </div>
          <div class="form-group col lab-0">
            <label class="form-heading tagline-0" for="inputEmail4">Required Fields <em>*</em></label>
          </div>
          <div class="row sp-fm0">
            <div class="col dis_1">
              <input type="text" class="form-control" [(ngModel)]="user.FirstName" placeholder="First Name *" name="FirstName" required>
              <span class="error errorFirstName">First name is required</span>
              <span class="error invalidFirstName">First name is invalid</span>
            </div>
            <div class="col dis_1">
              <input type="text" class="form-control" [(ngModel)]="user.LastName" placeholder="Last Name *" name="LastName" required>
              <span class="error errorLastName">Last name is required</span>
              <span class="error invalidLastName">Last name is invalid</span>
            </div>
          </div>
          <div class="row sp-fm0">
            <div class="col dis_1 ">
              <input type="text" class="form-control" [(ngModel)]="user.CompanyName" placeholder="Company Name *" name="CompanyName" required>
              <span class="error errorCompanyName">Company name is required</span>
              <span class="error invalidCompanyName">Company name is invalid</span>
            </div>
            <div class="col dis_1">
              <input type="text" class="form-control" [(ngModel)]="user.Email" placeholder="Email *" name="Email" required>
              <span class="error errorEmail">Email is required</span>
              <span class="error invalidEmail">Email is invalid</span>
            </div>
          </div>
          <div class="row sp-fm0">
            <div class="col dis_1">
              <input type="text" class="form-control" [(ngModel)]="user.PhoneNumber" placeholder="Phone Number *" name="PhoneNumber" required>
              <span class="error errorPhoneNumber">Phone number is required</span>
              <span class="error invalidPhoneNumber">Phone number is invalid</span>
            </div>




            <div class="col dis_1">
              <input type="text" class="form-control" placeholder="Physical Address *" [(ngModel)]="user.Address1" name="Address1" required>
              <span class="error errorAddress1">Address is required</span>
              <span class="error invalidAddress1">Address is invalid</span>
            </div>



          </div>
          <div class="row sp-fm0">




            <div class="col dis_1">
              <input type="text" class="form-control" placeholder=" City *" [(ngModel)]="user.City"  name="City" required>
              <span class="error errorCity">City is required</span>
              <span class="error invalidCity">City is invalid</span>
            </div>


            <div class="col col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsState">

              <select id="StateProvinceRegion" class="form-select" [(ngModel)]="user.StateProvinceRegion"  name="StateProvinceRegion" required>
                <option value="" class="state-color" disabled selected>State *</option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
              <span class="error errorStateProvinceRegion">State is required</span>
              <span class="error invalidStateProvinceRegion">State is invalid</span>
            </div>
            <div class="col  col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsZip">
              <input type="text" class="form-control on-full-width zip-pholder"  [(ngModel)]="user.ZipPostalCode" placeholder="Zip Code/Postal Code *"
                name="ZipPostalCode" required>
              <span class="error errorZipPostalCode">Zip Code is required</span>
              <span class="error invalidZipPostalCode">Zip Code is invalid</span>

            </div>
          </div>
          <div class="row sp-fm0">


            <div class="col dis_1">

              <select id="Country" class="form-select" [(ngModel)]="user.Country"  name="Country" required>
                <option value="" selected disabled>Country or Territory *</option>
                <option value="US">United States</option>
              </select>
              <span class="error errorCountry">Country is required</span>
              <span class="error invalidCountry">Country is invalid</span>
            </div>
            <div class="col dis_1">
              <select id="MaximumInsuredValue" class="form-select" [(ngModel)]="user.MaximumInsuredValue"  name="MaximumInsuredValue" required>
                <option value="" selected disabled>Bond Amount *</option>
                <option value="Minimum $50,000 Bond">Minimum $50,000 Bond</option>
                <option value="Bond amount greater than $50,000">Bond amount greater than $50,000
                </option>
              </select>
              <span class="error errorMaximumInsuredValue">Bond Amount is required</span>
              <span class="error invalidMaximumInsuredValue">Bond Amount is invalid</span>
            </div>
          </div>
          <div class="row sp-fm0">



            <div class="col dis_1">
              <input type="text" class="form-control" placeholder="Description of Merchandise *" [(ngModel)]="user.ProposalAgreement" 
                name="ProposalAgreement" required>
              <span class="error errorProposalAgreement">Description of Merchandise is required</span>
              <span class="error invalidProposalAgreement">Description of Merchandise is
                invalid</span>
            </div>

            <div class="col dis_1">

              <select id="MailingAddress" class=" word-wrap-class form-select" [(ngModel)]="user.MailingAddress"  name="MailingAddress" required>
                <option value="" selected disabled>Is mailing address different from <br
                    class="media-br-display">physical
                  address *</option>

                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
              <span class="error errorMailingAddress">Field is required</span>
              <span class="error invalidMailingAddress">Field Amount is invalid</span>
            </div>
          </div>



          <div class="option-yes-container">
            <div class="row sp-fm0">
              <div class="col dis_1">
                <input type="text" class="form-control" placeholder="Mailing Address *" name="WpCCFullName"  [(ngModel)]="user.WpCCFullName" required>
                <span class="error errorWpCCFullName">Mailing Address is required</span>
                <span class="error invalidWpCCFullName">Mailing Address is invalid</span>
              </div>




              <div class="col dis_1">
                <input type="text" class="form-control" placeholder="City *" name="WpCCLastFour" [(ngModel)]="user.WpCCLastFour" required>
                <span class="error errorWpCCLastFour">City is required</span>
                <span class="error invalidWpCCLastFour">City is invalid</span>
              </div>



            </div>
            <div class="row sp-fm0">




              <div class="col dis_1">

                <select id="UPSStoreNumber" class="form-select" name="UPSStoreNumber"  [(ngModel)]="user.UPSStoreNumber" required>
                  <option value="" selected disabled>Country or Territory *</option>
                  <option value="US">United States</option>
                </select>
                <span class="error errorUPSStoreNumber">Country is required</span>
                <span class="error invalidUPSStoreNumber">Country is invalid</span>
              </div>


              <div class="col col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsState">

                <select id="WpCCAgreement" class="form-select" name="WpCCAgreement"  [(ngModel)]="user.WpCCAgreement" required>
                  <option value="" class="state-color" disabled selected>State *</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </select>
                <span class="error errorWpCCAgreement">State is required</span>
                <span class="error invalidWpCCAgreement">State is invalid</span>
              </div>
              <div class="col  col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsZip">
                <input type="text" class="form-control on-full-width zip-pholder" placeholder="Zip Code/Postal Code *"
                  required  [(ngModel)]="user.WpProfileID" name="WpProfileID">
                <span class="error errorWpProfileID">Zip Code is required</span>
                <span class="error invalidWpProfileID">Zip Code/Postal Code is invalid</span>
              </div>
            </div>

          </div>













          <div class="row sp-fm0 row-with-no-margin-bottom label-show">

            <div class="col-4 dis_1 width-different-container">
              <label for="inputEmail4">Is merchandise subject to FDA, ADD or CVD?*</label>
            </div>


            <div class="col-2 dis_1 no-padding-left-container">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio"  [(ngModel)]="user.WpProfileChange" name="WpProfileChange" id="inlineRadio1" value="TRUE"
                  required>
                <label class="form-check-label media-padding-value" for="inlineRadio1">Yes</label>
              </div>
              <div class="form-check form-check-inline margin-left-on-media">
                <input class="form-check-input" type="radio"  [(ngModel)]="user.WpProfileChange" name="WpProfileChange" id="inlineRadio2" value="FALSE"
                  required>
                <label class="form-check-label media-padding-value" for="inlineRadio2">No</label>
              </div>

              <!-- <input type="text" class="form-control" placeholder="Last name"> -->
            </div>



            <div class="col dis_1 padding-no-container">

              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="defaultCheck1"  [(ngModel)]="user.agree" name="agree" required>
                <label class="label-text-colour form-check-label media-padding-left-value" for="defaultCheck1">
                  I agree to the <a data-bs-toggle="modal" data-bs-target="#custombondappmodal"
                    class="url-text-colour">Terms & Conditions</a>
                </label>
              </div>

            </div>
          </div>

          <div class="row sp-fm0">




            <div class="col dis_1">
            </div>


            <div class="col col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsState">


              <div class="g-recaptcha" data-callback="recaptchaCallback"
                data-sitekey="6LeWTwUcAAAAAP0S-FWFcCQqwCB7Bc1tj6uOegT_"></div>
              <span class="error errorCaptchaVal">Recaptcha is required</span>
              <span class="error invalidCaptchaVal">Recaptcha is invalid</span>
              <br>

            </div>

            <div class="col  col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsZip1">
              <div class="hero-panel-button sli-btn form-submit">
                <button class="get-secret-btn form-sub submit-form" tabindex="-1"  type="submit">Submit
                </button>
              </div>
            </div>






          </div>
        </form>
      </div>

    </div>



    <div class="card" id="contact-card">
      <div class="card-body">
        <h5 class=" card-title">Have Questions?</h5>

        <p class="card-text sub-para">Email a bond specialist.</p>

        <a class="trade-credit-a" href="mailto:bondapplication@ups.com">
          <button class="trade-credit__button">
            Send Email
            <img class="btn-not0" src="../../../../assets/redesignImages/sli-buttonArrow.png">
          </button>
        </a>
      </div>
      <img class="flexible-coverage-bg-image" alt="Business-services-img"
        src="../../../../assets/redesignImages/Gradient.png" width="350" height="200">
    </div>

  </div>

</div>

<!-- Modal -->
<div class="modal fade" id="custombondappmodal" tabindex="-1" aria-labelledby="custombondappmodalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="custombondappmodalLabel">Terms & Conditions</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Customs Certification, Indemnity Agreement and Collateral Policy I certify that the factual
        information contained in
        this application is true and accurate and any information provided which is based upon estimates is
        based upon the best
        information available on the date of this application. I certify that myself and/or a
        partner/officer has not filed
        bankruptcy or is currently in bankruptcy proceedings. I certify that myself and/or a partner/officer
        has not had a
        surety previously pay a customs claim on my behalf or have any pending customs claims. I certify
        that I have not had
        Customs suspend my immediate delivery privileges and/or are currently sanctioned by Customs & Border
        Protection. I
        certify that myself and/or a partner/officer has not been investigated by Customs for fraud or
        negligence and/or are
        currently involved in any investigation. I understand that all information contained herein or
        generated by CBP or other
        governmental agency or the Surety may be shared with the Customs Broker(s) of record acting on my
        behalf. I understand
        that there is a six (6) year statute of limitations for claims to be made against the bond(s) and
        collateral will not be
        returned until liability has been extinguished. For more information on Avalon’s collateral policy,
        please visit <a class="modalcustomclasshref" href="https://www.avalonrisk.com/collateral.pdf" target="_blank"
          rel="noopener">
          www.avalonrisk.com/collateral.pdf</a>. The Undersigned hereby declares the truth of the
        representations herein, and that
        they are made to induce Avalon Risk Management on behalf of SOUTHWEST MARINE AND GENERAL INSURANCE
        COMPANY and/or NEW
        YORK MARINE AND GENERAL INSURANCE COMPANY and/or GREAT AMERICAN ALLIANCE INSURANCE COMPANY and/or
        GREAT AMERICAN
        INSURANCE COMPANY and/or such other sureties as Avalon Risk Management may from time to time
        represent (hereinafter
        referred to collectively as the “Surety”) to enter into a contract of surety ship by the issuance of
        the Bond(s) applied
        for in accordance to 19 CFR part 113 as amended by Federal Register Notice 79 FR 70881. The
        Undersigned agrees that the
        Surety may decline the Bond(s) applied for or may cancel or terminate same without incurring any
        liability whatsoever to
        the Undersigned. In consideration of the issuance of the Bond(s) herein applied for, any previously
        issued Bond(s), or
        any Bond(s) in substitution for or in succession of the said Bond(s), or any increase or extension
        of time of the said
        Bond(s) or any Bond or surety ship obligation undertaken for the benefit of the Principal, whether
        executed in physical
        form or created through electronic means, the Undersigned hereby agrees: (1) To hereby authorize the
        Surety to make such
        pertinent inquiry as may be necessary from financial institutions, persons, firms and corporations
        in order to confirm
        and verify information referred to or listed herein; (2) To pay to the Surety the agreed premium
        upon execution of the
        Bond(s) and annually in advance thereafter; (3) To furnish the Surety with satisfactory and
        conclusive termination
        evidence that there is no further liability on the Bond(s); (4) To perform all the conditions of
        said Bond(s) and will
        indemnify and save the Surety harmless from demands, losses, costs, damages and expenses, including
        attorney’s and
        counsel fees deemed necessary by the Surety, which Surety may sustain or incur by reason of the
        issuance of such
        Bond(s), or obtaining a release of or evidence of termination under such Bond(s). This obligation
        shall be continuing as
        to this Bond or any other Bonds or undertaking until Surety’s liability is extinguished; (5) That
        the Surety shall have
        (i) the exclusive right to adjust, settle or compromise any claim under such Bond(s), and (ii) the
        right, at its sole
        option and sole discretion, to increase or decrease the penalty(s) of any such Bond(s), to change
        the obligee(s)
        therein, to execute any continuations, enlargements, modifications and renewals thereof or
        substitute the same or
        different conditions, provisions and obligee(s) therein, it being agreed that this Indemnity
        Agreement shall cover such
        new or changed Bond(s) or renewals even though the Surety’s action or consent may or does
        substantially increase the
        liability of the Applicant and the Undersigned; (6) That the voucher or other evidence showing
        payment made by the
        Surety in good faith by reason of such Bond(s) or any renewal, extension or substitution thereof
        shall be conclusive and
        in any event prima facie evidence of such payment and the property thereof and of the liability of
        the Undersigned
        theretofore to the Surety; (7) To the following general provisions: a. Any property which may have
        been, or maybe,
        pledged as collateral security for any Bonds may, at the Surety’s discretion, be retained as
        collateral security on any
        Bond falling under the scope of this Indemnity Agreement, whether or not executed, and whether or
        not executed or
        reinsured by the Surety, and for the full and complete performance of the Undersigneds’ covenants
        under this Indemnity
        Agreement. In the case of any breach of the Undersigneds’ covenants, or in case the Surety finds it
        necessary to raise
        money to meet any actual or prospective claim or demand under any Bond, or to pay any expense
        incurred in connection
        therewith, the Surety has full power and authority, without notice to the Undersigneds, to negotiate
        or redeem any
        checks or certificates of deposit, or to draw upon any letters of credit, and to use any or all of
        the proceeds, in
        order to protect itself against loss, costs, damages, attorneys’ fees and expenses. After deducting
        all legal and other
        costs, and all loss, costs, damages, attorneys’ fees and expenses, and all premiums due the Surety
        for any Bond or
        Bonds, the Surety shall return the remainder of the collateral, if any, to the person or persons
        legally authorized to
        receive it. We will contact you at the name and address provided and/or through your customs broker
        when the collateral
        may be returned. It is the principal’s obligation to notify us of any change of address. If we are
        unable to contact you
        funds that we continue to hold on your behalf will become subject to a maintenance fee of 1.5% per
        month effective as of
        the return date of undeliverable certified mail to your last known address. The Surety shall not be
        responsible for any
        loss to the property from any cause other than the act or neglect of its officers or employees. The
        Surety shall not be
        responsible for paying interest, or loss of interest, to depositor or any other party on such
        deposits; b. Where a Bond
        has been executed for the importation of merchandise, or transportation in-bond of imported
        merchandise, to consent to
        service of process upon the Customs broker or agent who executed the Bond on behalf of the
        Principal. Principals further
        consent to such service, at the Surety’s sole option, at the original port of entry, the final port
        of entry, or other
        place, as may be a place of business of the Customs broker or agent. The Principal consents to
        jurisdiction at the place
        of service; c. Where the bonded merchandise is a motor vehicle, a condition of executing the Bond is
        the immediate
        delivery of the vehicle to a Surety-approved bonded conversion facility. The delivery must occur
        directly from the port
        of entry to the conversion facility in order to perform all conversions necessary to bring the
        vehicle into conformity
        with United States Environmental Protection Agency and Department of Transportation emission and
        safety standards; d.
        The Principals agree to give the Surety prompt written notice of any and all facts which may give
        rise to any action
        against the Surety relating to any Bond. If the Principals fail to petition, protest, defend or
        settle any such action
        taken by the Obligee, pursuant to the Bond, the Principals agree that the Surety may petition,
        protest, defend or settle
        such action to protect its interests by whatever means it considers appropriate. The determination
        as to whether any
        such action is petitioned, protested, defended or settled is binding and conclusive upon the
        Principals, and the result
        of any such petition, protest, defense or settlement is binding in whole or in part, as if it were
        the act of the
        Principals. Evidence of payment is prima facia evidence of the fact and extent of the Principals’
        liability to the
        Surety. Liability hereunder extends to, and includes, the full amount of any and all monies paid by
        the Surety in
        settlement or compromise of any action, in good faith under the belief that it was liable therefore,
        whether liable or
        not, as well as any and all disbursements for attorneys’ fees, costs, and expenses as aforesaid,
        which may be made under
        the belief that such were necessary, whether necessary or not. The Principals understand that any
        action taken to
        petition, protest, defend or settle any action by the Obligee under the Bond, whether the action is
        initiated by the
        Principals or the Surety, does not excuse the Principals from the timely payment of bills for the
        Bond or for amounts
        paid in pursuance thereof; e. The Surety has every right, defense, or remedy available, including
        the right of
        exoneration and replevin or to take possession of the bonded merchandise upon notification of any
        violation of the terms
        and conditions of the Bond. The Surety has specific lien rights as to both real and personal
        property, including
        merchandise in which the Undersigneds’ is the owner and/or has ownership interest in, including
        merchandise in transit
        and/or in a warehouse. (8) To consent to provide the Surety, any Bond Obligee and/or Customs broker,
        any and all
        information relative to entries or other transactions under any Bond; (9) To consent to their lawful
        agent or
        attorney-in-fact executing and filing Bonds, by electronic or such other means as is elected instead
        of paper documents,
        and agree in those instances to be bound by this Indemnity Agreement and the terms and conditions of
        any Bonds as fully
        and completely as they would be if paper documents had been used and manually executed; (10) The
        Principals understand
        and agree that the Bond or undertaking is subject to termination if the Principals no longer use a
        licensed Customs
        broker satisfactory to the Surety; (11) The Undersigned further agrees to reimburse the Surety for
        all expense, counsel
        and attorney fees incurred by the Surety in enforcing any provision of this agreement. Regardless of
        the date this
        Indemnity Agreement is signed, it is effective as of the date of the execution of the above
        mentioned Bond(s). Customs
        Bonds are underwritten by an authorized insurance company and issued through licensed insurance
        producers affiliated
        with UPS Capital Insurance Agency, Inc., and other affiliated insurance agencies. UPS Capital
        Insurance Agency, Inc. and
        its licensed affiliates are wholly owned subsidiaries of UPS Capital Corporation. The insurance
        company, UPS Capital
        Insurance Agency, Inc. and its licensed affiliates reserve the right to change or cancel the program
        at any time.
        Insurance coverage is not available in all jurisdictions.
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>